import ReactOnRails from 'react-on-rails';

import LandingPage from '@components/pages/LandingPage';

ReactOnRails.register({
  LandingPage,
});
